import { render, staticRenderFns } from "./ActionNoticeAssignManager.vue?vue&type=template&id=bef9c716&"
import script from "./ActionNoticeAssignManager.vue?vue&type=script&lang=js&"
export * from "./ActionNoticeAssignManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports